<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div
            class="col-12 d-flex align-items-center justify-content-between mb-4"
          >
            <div>
              <button class="btn btn-primary" @click="$refs.modal.open()">
                <i class="fas fa-link" />
                {{ $t("Vincular") }}
              </button>
            </div>
            <div>
              <div class="input-group mb-3">
                <b-input
                  :placeholder="$t('Type to search')"
                  class="form-control search-input"
                  type="text"
                  v-model="search"
                  v-on:change="getLocalidades"
                  aria-describedby="input-search"
                />
                <div class="input-group-append" role="button">
                  <span class="input-group-text" id="input-search"
                    ><i class="fas fa-search search-icon"
                  /></span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <load mode="table" v-if="loading" />
            <div v-else>
              <b-table
                :fields="[
                  {
                    key: 'nome_localidade',
                    label: $t('Bairro/Localidade'),
                  },
                  {
                    key: 'quant_logradouros',
                    label: $t('Qtd. Logradouros'),
                  },
                  {
                    key: 'cadastrado',
                    label: $t('Vinculado em'),
                  },
                  {
                    key: 'actions',
                    label: '',
                    class: 'text-right',
                    thStyle: { width: '120px', minWidth: '120px' },
                  },
                ]"
                :items="localidadesVinculadas"
                :responsive="true"
                striped
                hover
                show-empty
                small
                outlined
                stacked="md"
                table-class="mb-3"
              >
                <template v-slot:cell(nome_localidade)="data">
                  {{ data.value }}
                </template>
                <template v-slot:cell(quant_logradouros)="data">
                  {{ data.value }}
                </template>
                <template v-slot:cell(cadastrado)="data">
                  {{ data.value }}
                </template>
                <template v-slot:cell()="data">
                  <b-button
                    :title="$t('Desvincular Localidade')"
                    class="px-2 mb-0"
                    size="xs"
                    type="button"
                    v-b-tooltip.hover
                    variant="danger"
                    @click.prevent="desvincularAbrangencia(data.item.id)"
                  >
                    <i class="fas fa-minus-circle"></i>
                    {{ $t("Desvincular") }}
                  </b-button>
                </template>
                <template v-slot:empty="scope">
                  <div class="text-center my-5">
                    <img
                      :alt="$t('No results')"
                      class="mb-5"
                      src="/img/icons/robot.svg"
                      style="max-height: 165px"
                    />
                    <h3 class="bold">{{ $t("No records found") }}</h3>
                  </div>
                </template>
                <template v-slot:emptyfiltered="scope">
                  <div class="text-center my-5">
                    <img
                      :alt="$t('No results')"
                      class="mb-5"
                      src="/img/icons/robot.svg"
                      style="max-height: 165px"
                    />
                    <h3>{{ $t("No records match the entered search") }}</h3>
                  </div>
                </template>
              </b-table>

              <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                  <div class="form-group d-inline-flex mb-0">
                    <select
                      class="form-control"
                      style="width: 70px"
                      v-model="perPage"
                      v-on:change="getLocalidades"
                    >
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                    </select>
                  </div>
                  <div class="d-inline-flex ml-2">
                    <b-pagination
                      :per-page="perPage"
                      :total-rows="pagination.total"
                      @change="changePage"
                      v-model="page"
                    />
                  </div>
                </div>
                <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                  <div class="float-lg-right">
                    {{ $t("Showing page") }} {{ pagination.currentPage }}
                    {{ $t("of") }} {{ pagination.totalPages }}
                    {{ $t("pages in") }} {{ pagination.total }}
                    {{ $t("records") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <routerView /> -->
    <ModalAdd ref="modal" :id="$route.params.id" @reload="getLocalidades" />
  </div>
</template>

<script>
import ModalAdd from "./AbrangenciaAdd";
export default {
  components: { ModalAdd },
  name: "Abrangencia",
  data() {
    return {
      page: 1,
      search: "",
      perPage: 10,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      localidadesVinculadas: [],
    };
  },
  mounted() {
    this.getLocalidades();
  },
  methods: {
    // Change the page
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getLocalidades();
      }
    },
    // Get roles list
    getLocalidades() {
      this.loading = true;
      axios
        .get("api/dashboard/unidades/localidadesvinculadas", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            id: this.$route.params.id,
          },
        })
        .then((response) => {
          this.localidadesVinculadas = response.data.data;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            // this.getLocalidades();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    desvincularAbrangencia(id) {
      swal
        .fire({
          title: "Tem certeza disso?",
          html:
            "Este bairro será removido da lista de abrangencia da sua Unidade",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonText: "Confirmar",
          icon: "warning",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.loading = true;
            axios
              .delete("api/dashboard/unidades/desvincularbairro/" + id)
              .then((response) => {
                this.getLocalidades();
                this.$snack.success({
                  button: false,
                  text: response.data.data.message,
                });
              })
              .catch(() => {
                this.loading = false;
              });
          }
        });
    },
  },
};
</script>
